
    var ret = {
      defaultLocale: "en-US",
      fallbackLocale: "en-US",
      availableLocales: ["af-ZA","ar-AE","da","de","de-CH","en-US","es","fi-FI","fr-FR","hu","id-ID","it-IT","ja-JP","nb-NO","nl-NL","pl","pt-BR","ro","ru","sv","tr-TR","zh-CN"],
      bundled: {},
      loadables: {},
    };

  // Bundled locales are directly available in the main bundle.
  
    {
      var suffixes = [".ftl"];
      var contents = [];
    
      contents.push(require("/tmp/build_b2872182/src/locales/en-US/common.ftl").default);
    

      contents.push(require("/tmp/build_b2872182/src/locales/en-US/framework.ftl").default);
    

      contents.push(require("/tmp/build_b2872182/src/locales/en-US/ui.ftl").default);
    
      contents = contents.concat(suffixes.map(function(suffix) { return require("/tmp/build_b2872182/src/locales/en-US/admin" + suffix).default; }));
      ret.bundled["en-US"] = contents.join("\n");
    }
  

  // Loadables are in a separate bundle, that can be easily loaded.
  
    ret.loadables["af-ZA"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-af-ZA", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/af-ZA/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-af-ZA", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/af-ZA/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ar-AE"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ar-AE/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ar-AE/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ar-AE/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/ar-AE/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["da"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/da/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/da/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/da/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/da/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/de/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/de/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/de/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/de/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de-CH"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/de-CH/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/de-CH/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/de-CH/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["es"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/es/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/es/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/es/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/es/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fi-FI"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/fi-FI/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/fi-FI/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/fi-FI/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fr-FR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/fr-FR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/fr-FR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/fr-FR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/fr-FR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["hu"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/hu/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/hu/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/hu/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/hu/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["id-ID"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/id-ID/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/id-ID/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/id-ID/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/id-ID/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["it-IT"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/it-IT/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/it-IT/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/it-IT/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/it-IT/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ja-JP"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ja-JP/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ja-JP/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ja-JP/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/ja-JP/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nb-NO"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nb-NO/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nb-NO/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nb-NO/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/nb-NO/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nl-NL"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nl-NL/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nl-NL/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/nl-NL/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/nl-NL/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pl"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pl/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pl/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pl/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/pl/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pt-BR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pt-BR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pt-BR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/pt-BR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/pt-BR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ro"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ro/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ro/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/ro/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ru"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ru/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ru/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/ru/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/ru/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["sv"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/sv/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/sv/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/sv/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/sv/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["tr-TR"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/tr-TR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/tr-TR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/tr-TR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/tr-TR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["zh-CN"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/zh-CN/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/zh-CN/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/tmp/build_b2872182/src/locales/zh-CN/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy-once" */
          "/tmp/build_b2872182/src/locales/zh-CN/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  
    module.exports = ret;
  